import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Document, Page, pdfjs } from "react-pdf";
import { AiOutlineDownload } from "react-icons/ai";
import Particle from "../Particle";
import pdf from "../../Assets/Benedict-Kpaduwa-resume.pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-dark via-dark-light to-dark py-32">
      <Particle />

      <div className="container mx-auto px-4 relative z-10">
        {/* Download Button - Top */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex justify-center mb-8"
        >
          <a
            href={pdf}
            target="_blank"
            rel="noopener noreferrer"
            download="Benedict-Kpaduwa-CV.pdf"
            className="inline-flex items-center gap-2 btn-primary"
          >
            <AiOutlineDownload className="text-xl" />
            <span>Download CV</span>
          </a>
        </motion.div>

        {/* PDF Viewer */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex justify-center mb-8"
        >
          <div className="glass-effect rounded-xl p-4 shadow-2xl shadow-purple-500/20">
            <Document
              file={pdf}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={
                <div className="flex items-center justify-center h-96">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-purple-500"></div>
                </div>
              }
              error={
                <div className="flex items-center justify-center h-96 text-red-400">
                  <p>Failed to load PDF. Please try downloading it instead.</p>
                </div>
              }
            >
              {Array.from(new Array(numPages || 1), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  scale={width > 786 ? 1.7 : 0.6}
                  renderTextLayer={true}
                  renderAnnotationLayer={true}
                  className="mb-4"
                />
              ))}
            </Document>
          </div>
        </motion.div>

        {/* Download Button - Bottom */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex justify-center"
        >
          <a
            href={pdf}
            target="_blank"
            rel="noopener noreferrer"
            download="Benedict-Kpaduwa-CV.pdf"
            className="inline-flex items-center gap-2 btn-primary"
          >
            <AiOutlineDownload className="text-xl" />
            <span>Download CV</span>
          </a>
        </motion.div>
      </div>
    </div>
  );
}

export default ResumeNew;
